import { getToken } from './user-service';
import { selectFirebaseUser, selectUserDb, getDbInfo, selectIata } from '_redux/slices/main-screen/user';
import { useSelector, useDispatch, } from 'react-redux';
import { selectSelectedConversation } from '_redux/slices/messaging/messaging';

import { collection, getDocs, addDoc, query, where, orderBy, doc, updateDoc, deleteDoc, getDoc, setDoc } from "firebase/firestore";
import { firestore } from '_utils/firebase-app';
import firebaseapp from '_utils/firebase-app';
import axios from 'axios';


// todo there are authentication problems with this 


// get scores for heatmap
export const getConversations = async (params) => {
  const collectionRef = collection(firestore, 'conversations')
  const q = await query(collectionRef, where('portalUser', '==', params.iata))
  const querySnapshot = await getDocs(q)
  const ids = await querySnapshot.docs.map((doc) => {
    const data = doc.data(); // Get the document data
    return {
      id: doc.id, // Save the document ID
      ...data, // Save the document fields
    };
  });
  return ids
};

export const archiveChat = async (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      const docRef = doc(firestore, `conversations/${params.conversationId}/`);
      await updateDoc(docRef, {
        archived: params.archive
      });
      resolve();
    } catch (error) {
      console.log('error deleting doc', error);
      reject(error)
    }
  })
};

export const deleteChat = async (conversationId) => {

  console.log('deleting doc...', conversationId);

  return new Promise(async (resolve, reject) => {
    try {
      const docRef = doc(firestore, `conversations/${conversationId}/`);
      await deleteDoc(docRef);
      resolve();
    } catch (error) {
      console.log('error deleting doc', error);
      reject(error)
    }
  })
};

export const createSupportDesk = async (newSupportDesk) => {
  console.log('creaating desk:', newSupportDesk);

  return new Promise(async (resolve, reject) => {
    try {

      const docRef = doc(firestore, 'support-desks', newSupportDesk.iata);

      // Update the document with the new data
      await setDoc(docRef, newSupportDesk);

      resolve(newSupportDesk);
    } catch (error) {
      console.error('Error updating desk:', error);
      reject(error);
    }
  });
};

export const updateSupportDesk = async (newSupportDesk) => {
  console.log('updating desk by IATA:', newSupportDesk);

  return new Promise(async (resolve, reject) => {
    try {
      const docRef = doc(firestore, `support-desks/${newSupportDesk.iata}`);

      // Update the document with the new data
      await updateDoc(docRef, newSupportDesk);

      resolve(newSupportDesk);
    } catch (error) {
      console.error('Error updating desk:', error);
      reject(error);
    }
  });
};

export const getSupportDesk = async (iata) => {
  console.log('getting desk by IATA:', iata);

  return new Promise(async (resolve, reject) => {
    try {
      const docRef = doc(firestore, `support-desks/${iata}/`);
      const docSnapshot = await getDoc(docRef);

      if (docSnapshot.exists()) {
        const deskData = docSnapshot.data();
        //console.log('Desk Data:', deskData);
        resolve(deskData);
      } else {
        resolve(null);
      }
    } catch (error) {
      console.error('Error fetching desk:', error);
      reject(error);
    }
  });
};



export const getMessages = async (params) => {
  const collectionRef = collection(firestore, `conversations/${params.conversation}/messages`)
  const q = await query(collectionRef, orderBy('timeStamp', 'asc'))
  const querySnapshot = await getDocs(q)
  const docs = await querySnapshot.docs.map((doc) => {
    return doc.data()
  });
  return docs
};

export const clearNotification = async (conversationId) => {
  return new Promise(async (resolve, reject) => {
    try {
      const conversationDocRef = doc(firestore, `conversations/${conversationId}`)

      // Update the document to set the "notification" field to false
      await updateDoc(conversationDocRef, {
        notification: false,
      });

      resolve({ 'conversationId': conversationId })

    } catch (error) {
      console.error('Error clearing notification:', error);
      reject(error)
    }
  })
}

export const postMessage = async (params) => {
  // Reference to the messages collection
  const messagesCollectionRef = collection(firestore, `conversations/${params.tempSelectedConversationId}/messages`);

  let timeStamp = new Date();

  // Add the message to the collection
  const messageDocRef = await addDoc(messagesCollectionRef, {
    text: params.message,
    userId: params.userId,
    iata: params.iata,
    timeStamp: timeStamp,
    id: params.userId + timeStamp.toISOString(),
  });

  // Reference to the conversation document
  const conversationDocRef = doc(firestore, `conversations/${params.tempSelectedConversationId}`);

  console.log('updating notification field...');

  // Update the 'notification' field to true in the conversation document
  const response = await updateDoc(conversationDocRef, {
    appNotification: true,
    lastAction: timeStamp
  });

  console.log('response', response)

  return messageDocRef;
};

export const postNotification = async (params) => {
  console.log('positng notification', params)
  let url = '/api/v1/mobileusers/notification/'

  return new Promise(async (resolve, reject) => {

    const token = await getToken();

    try {

      const response = await fetch(url, {
        method: "POST",
        body: JSON.stringify(params),
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          "firebase-uid": token
        }
      })

      console.log('response from posting notification...', response)
      resolve(response)

    } catch (e) {
      console.log('e', e)
      reject(new Error(e))
    }

  });
}

export const getCustomAuthToken = async () => {
  const url = "/api/v1/mobileusers/customtoken"
  const token = await getToken();

  const response = await fetch(url, {
    method: "GET",
    headers: {
      accept: "application/json",
      "Content-Type": "application/json",
      "firebase-uid": token
    },
  });

  const json = await response.json();

  if (response.status >= 400 && response.status < 600) {
    throw new Error("Error");
  }

  return json.token;
}